var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadimg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392,419.82c-36.31,2.52-96.64,1.67-96.64,1.67-31.14-2.27-37-12.54-32.14-24.23,7.57-18,40.82-39.35,46.88-39.85,10-.81,20.52,3.16,20.52,3.16l6.5-1.37c-2-5.39,18.55-17.39,27.94-12.21s28.8-1.93,34.65,1.72a13.65,13.65,0,0,1,3.92,3.83,23.12,23.12,0,0,1,3.43,8.16h0l.08,0h0a21.13,21.13,0,0,1,4.5-.7c3.22-.17,7.51.32,10.87,3.25a32.4,32.4,0,0,1,2.45,2.42c6.06,6.62,13.86,19.13,15.66,26.43C442.72,400.4,428.3,417.29,392,419.82Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75,364s-.57,25.77,42.1,44.77S275.73,437,296.86,370.06l-65.71-18.87H143L123.6,360Z",
    style: {
      fill: "#FECB63",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.87,369.84v4.29a3.17,3.17,0,0,1-.08.69A2.92,2.92,0,0,1,239,377H137.18a2.92,2.92,0,0,1-2.83-2.2,3.17,3.17,0,0,1-.08-.69v-4.29Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.36,432.33c-6.93,7.23-29.13,8.67-38.4,6.56-2.53-.58-11.74-.91-18.6-3.37-3.7-1.31-6.72-3.24-7.64-6.16-2.66-8.33,20.78-24.18,20.78-24.18s14.95,2.88,18.05,3.62a59.14,59.14,0,0,0,11,1.52c7.11.31,11.92-.64,17.13,1.6C278.58,414.47,278.66,423.67,270.36,432.33Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.27,401.35c-2.23,15.11-25.53,31.53-25.53,31.53s-6.45-6.05-8.58-5.8-11-.38-11-.38S113,400.44,104.58,400.3c-5.26-.08-20.42-4.69-27.92-16.65-4.46-7.1-6.21-16.8-1.6-29.67,7.6-21.23,45.07-5.59,81.81,14.7,12.2,6.75,23,12.16,31.77,16.28,14.55,6.85,23.4,10.15,23.4,10.15l4.86-1.74Z",
    style: {
      fill: "#FECB63",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407,152.6s-14-1.55-22.57-16.92-54.6-10.32-54.6-10.32.27,5.38,7.39,6.77l-5,2.4s1.46,6.16,14.5,5.61L343.24,144s5.48,4.47,19.22,2.51l-2.59,3.33s6.42,4.47,17.32,1.33L376,154.22s8.26.6,13.13-1.53C389.15,152.69,398.57,158.5,407,152.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414,131.11l-4.84,1.67-2.32-4.85a1.08,1.08,0,0,0-1.35-.56L389,133a1.32,1.32,0,0,0-.86,1.33l.43,5.49-27.49,9.47a2.74,2.74,0,0,0-1.72,3.26l11.1,41.85a2.31,2.31,0,0,0,3,1.62l52.89-18.22a2.76,2.76,0,0,0,1.73-3.26L417,132.74A2.32,2.32,0,0,0,414,131.11Z",
    style: {
      fill: "#FECB63",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.08,177.89l-52.89,18.22a2.92,2.92,0,0,1-3.48-1.47l-.26-.53L357,168.28l-6.17-12.76a2.2,2.2,0,0,1,1.27-3.11L405,134.2a2.9,2.9,0,0,1,3.48,1.46l18.91,39.13A2.19,2.19,0,0,1,426.08,177.89Z",
    style: {
      fill: "#FECB63",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-9--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.3,168.62s-13.72,3-26.81-8.78-55,7.74-55,7.74,2,5,9.16,4l-3.93,3.87s3.35,5.36,15.53.66l-2.13,4.75s6.62,2.48,19-3.79l-1.39,4s7.52,2.17,16.83-4.29l-.11,3.3s8-2.09,11.95-5.66C371.4,174.45,382.18,176.92,388.3,168.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bricks--inject-74"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.34,
    y: 314.69,
    width: 24.95,
    height: 10.02,
    transform: "translate(625.63 639.41) rotate(180)",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.87,
    y: 301.47,
    width: 24.95,
    height: 10.02,
    transform: "translate(600.69 612.95) rotate(180)",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.61,
    y: 220.57,
    width: 24.95,
    height: 10.02,
    transform: "translate(486.18 451.16) rotate(180)",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.28,
    y: 208.1,
    width: 24.95,
    height: 10.02,
    transform: "translate(513.51 426.22) rotate(180)",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.14,
    y: 95.21,
    width: 24.95,
    height: 10.02,
    transform: "translate(699.23 200.45) rotate(180)",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.96,
    y: 81.87,
    width: 24.95,
    height: 10.02,
    transform: "translate(672.86 173.76) rotate(180)",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.43,
    y: 87.27,
    width: 24.95,
    height: 10.02,
    transform: "translate(311.81 184.56) rotate(180)",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.25,
    y: 73.93,
    width: 24.95,
    height: 10.02,
    transform: "translate(285.44 157.88) rotate(180)",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.49,
    y: 130.48,
    width: 24.95,
    height: 10.02,
    transform: "translate(461.94 270.99) rotate(180)",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.63,
    y: 191.19,
    width: 24.95,
    height: 10.02,
    transform: "translate(728.21 392.39) rotate(180)",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.27,
    y: 278.99,
    width: 24.95,
    height: 10.02,
    transform: "translate(787.49 568.01) rotate(180)",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.57,
    y: 220.57,
    width: 24.95,
    height: 10.02,
    transform: "translate(542.08 451.16) rotate(180)",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.16,259.71c-24.25-.27-49.25-.27-72.76,0",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.15,259.71h-6.09",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,287.91c24.25.27,49.25.27,72.76,0",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.05,287.91h6.1",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.32,156.27h3.44",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.07,156.27h32.35",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.47,
    y: 220.99,
    width: 24.95,
    height: 10.02,
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.58,205.23H61.14",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.84,205.23H68.49",
    style: {
      fill: "none",
      stroke: "#FECB63",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-74"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 34.79,
    y1: 406.03,
    x2: 465.21,
    y2: 406.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bag--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.28,416.19s-6.44,9.11.23,12.17,65.73-4,93.37-4.26,42.74-10.7,42.15-13.86-7.33-9.18-7.33-9.18L423,406.55s5,1.5,4.86,3.82-18.45,9.87-41.48,6.69-72.11,6.68-76,6.24-.17-9.14-.17-9.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,419.82c-36.31,2.52-96.64,1.67-96.64,1.67-31.14-2.27-37-12.54-32.14-24.23,7.57-18,40.82-39.35,46.88-39.85,10-.81,20.52,3.16,20.52,3.16l6.5-1.37c-2-5.39,18.55-17.39,27.94-12.21s28.8-1.93,34.65,1.72a13.65,13.65,0,0,1,3.92,3.83,23.12,23.12,0,0,1,3.43,8.16h0l.08,0h0a21.13,21.13,0,0,1,4.5-.7c3.22-.17,7.51.32,10.87,3.25a32.4,32.4,0,0,1,2.45,2.42c6.06,6.62,13.86,19.13,15.66,26.43C442.72,400.4,428.3,417.29,392,419.82Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-74)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.87,352.66c-1.77-3.11,20.58-1.64,22.95,0s2.38,6.78,4.95,5.39c2.05-1.1,9.86-5.33,14.86-5.51a23.12,23.12,0,0,1,3.43,8.16s-30.75,8.69-32.73,6.38,5.54-4.23,7.91-9.3-7.12-3.68-9.09-3.64S362.64,355.76,360.87,352.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,419.82c-36.31,2.52-96.64,1.67-96.64,1.67-31.14-2.27-37-12.54-32.14-24.23,1.2.94,3.26,1.36,6.64.71,11.11-2.14,17.43-2.73,24.56,4s15.24,10.82,19,9.5c0,0,.52-14.86,15-25.53s17.89-7.64,20.78-10.47,4.6-8-3.7-10.92-12.34-4-12.34-4,9.14-.71,17.06,2.84,14.83,12,11.47,13.91,4.94,5.31,10.68,4.4c5.08-.82,21.94-.91,25.32-1.05-3,.64-16.42,4.83-16.42,8.05,0,0,4.14,6.8,4.11,14.49s9,8.67,12.91,5.79,4.73-6.83,3.25-14.35-5.62-8.08-11-6.91c0,0,6.92-4.17,9.1-2.79s8.3.8,9.49,7.32-3,11.87-1,13.65,13.45-.2,15.43-4,.67-25.57-1.24-26-11.46,2.47-11.73,2.55a7.72,7.72,0,0,1,5.85-5c3.52-.62,7.86-4.08,8.55-7.86,6.06,6.62,13.86,19.13,15.66,26.43C442.72,400.4,428.3,417.29,392,419.82Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M392,419.82c-36.31,2.52-96.64,1.67-96.64,1.67-31.14-2.27-37-12.54-32.14-24.23,7.57-18,40.82-39.35,46.88-39.85,10-.81,20.52,3.16,20.52,3.16l6.5-1.37c-2-5.39,18.55-17.39,27.94-12.21s28.8-1.93,34.65,1.72a13.65,13.65,0,0,1,3.92,3.83,23.12,23.12,0,0,1,3.43,8.16h0l.08,0h0a21.13,21.13,0,0,1,4.5-.7c3.22-.17,7.51.32,10.87,3.25a32.4,32.4,0,0,1,2.45,2.42c6.06,6.62,13.86,19.13,15.66,26.43C442.72,400.4,428.3,417.29,392,419.82Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.62,360.57s4.55,1.52,16,4.25,5.14,12-3.17,12.5S313.81,396.39,313.41,409,330,419.77,330,419.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.13,359.2s15.84-.67,26.52,5.62,39.17-2.51,39.17-2.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.24,388.72C387,395.24,385,416.1,385,416.1s31.37-2.86,40-9.88,1.13-29.86-3.62-30.71-22.15,9.07-36,11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.39,388.72s9.89-3.76,11.87,0,5.9,16.48,3.56,20.89-11.08,3.59-11.08,3.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.2,349s12.64,5.33,19.77,5.23,15.44-.63,12.27,3.59a67.06,67.06,0,0,0-3.95,5.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,396.05s14.21,5,29.64,2.67,17.95.45,17.95.45v10.44s-10-1.85-16.37,0-27.3,3.26-36.79-.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.81,403.21s5.23,1.46,18.33,1.49,25.37-1.08,25.37-1.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.72,372.55l-.41-4.55a1.05,1.05,0,0,1,.82-1.11l10.62-2.32a1,1,0,0,1,1.26.91l.43,4.3a1.06,1.06,0,0,1-.79,1.12L313,373.47A1,1,0,0,1,311.72,372.55Z",
    style: {
      fill: "#FECB63",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.58 367.55 321.32 368.54 320.04 369.3 313.9 368.42 315.58 367.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.35,362a12,12,0,0,1,7-2.83c3.85,0,6.82,1.19,6.42,1.42s-6.52,1.43-7.66,2.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.29,410.26s-12.46,4.07-5.74,8.82,15.83,3.76,23.24-1l.79-4.45a30.34,30.34,0,0,0-8.4,2.58c-3.86,2-12.86,0-12.27-1.1a2.68,2.68,0,0,1,2.18-1.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.68,421.19c.92,5,35.68-2.2,63.91-7.18s53.2.79,55.28-3.64,7.16-.13,7.16-.13a23.34,23.34,0,0,1-11.66,11c-8.28,3.39-47.17,2.6-69,7.07s-60.56,11-57.77-6Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75,364s-.57,25.77,42.1,44.77S275.73,437,296.86,370.06l-65.71-18.87H143L123.6,360Z",
    style: {
      fill: "#FECB63"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-74)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75,364s-.57,25.77,42.1,44.77S275.73,437,296.86,370.06l-65.71-18.87H143L123.6,360Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75,364s-.57,25.77,42.1,44.77S275.73,437,296.86,370.06l-65.71-18.87H143L123.6,360Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.09,250.85c-7.74,6.91-34.58,85-31.11,93.52s49,16.3,49,16.3-4.5-88.17-4.73-89.64S125.09,250.85,125.09,250.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.68,250.85c7.74,6.91,34.58,85,31.11,93.52s-49,16.3-49,16.3,4.5-88.17,4.73-89.64S245.68,250.85,245.68,250.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.09,250.85s17.86-20.18,60.1-21.38c33.94-1,57.17,15.85,60.49,21.38s-15.1,79.24-15.1,79.24l10.31,39.68s-55.29,18.42-104.67,0l6.63-41.9S125.46,261.17,125.09,250.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.75,237.58s-15.3,16.86-30.83,12.16",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,268.7a87.4,87.4,0,0,0,10.83,1.4",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.07,247.48c9.71,8.83,24,16.39,39.15,20.17",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.3,265a48.11,48.11,0,0,0-5.64,19.51",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.37,254.17a53.5,53.5,0,0,0-4.46,6.2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.76,275.17c-6.91,3-13.27,13.82-13.27,13.82a83.34,83.34,0,0,1,6.63,17.69",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.25,332.67s6.47-1.05,10.51-5.37,15.75-3.16,17.41,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.9,322.13s4.15-6.32,13.27-1.9",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.68,256.11s9.11,6.07,10,22.64",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.88,295.39c-2.47,6.83-5.15,13.81-6.49,21",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.64,278.75c2.41.61,7.88,2.9,8.34,5.72.22,1.31-1.7,4.45-2.15,5.65",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.7,323a5.6,5.6,0,0,1,5.28,1.52",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7,327.3a34.84,34.84,0,0,1,5.19-2.85",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.82,330.45s.59-4.93,8.86-3.15,27.9,7.86,27.9,7.86",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.9,236.05s-9.5,9.35-21,9.35-22.48-10.83-22.48-10.83,5.93-2.95,7.52-8.86a9.58,9.58,0,0,0,.24-1.09c.43-2.59-.26-7-1.26-11.35-1.57-6.85-3.9-13.71-3.9-13.71h37.15s-1.76,8.57-2.92,16.47c-.21,1.45-.41,2.87-.56,4.22s-.31,2.8-.38,4C198.85,232.62,206.9,236.05,206.9,236.05Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.87,369.84v4.29a3.17,3.17,0,0,1-.08.69A2.92,2.92,0,0,1,239,377H137.18a2.92,2.92,0,0,1-2.83-2.2,3.17,3.17,0,0,1-.08-.69v-4.29Z",
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-74)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.87,369.84v4.29a3.17,3.17,0,0,1-.08.69H134.35a3.17,3.17,0,0,1-.08-.69v-4.29Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241.87,369.84v4.29a3.17,3.17,0,0,1-.08.69A2.92,2.92,0,0,1,239,377H137.18a2.92,2.92,0,0,1-2.83-2.2,3.17,3.17,0,0,1-.08-.69v-4.29Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.86,372.7H135.27a2.12,2.12,0,0,1-2.14-1.65l-9.17-74a2,2,0,0,1,2-2.27H250.18a2,2,0,0,1,2,2.27l-9.17,74A2.1,2.1,0,0,1,240.86,372.7Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.7,371.14l-9-70.93a1.46,1.46,0,0,1,1.43-1.61H248a1.47,1.47,0,0,1,1.44,1.61l-9,70.93",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.7,371.14l-9-70.93a1.46,1.46,0,0,1,1.43-1.61H248a1.47,1.47,0,0,1,1.44,1.61l-9,70.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.27 340.19 178.42 340.19 191.02 326.99 185.17 337.47 189.27 340.19",
    style: {
      fill: "#FECB63",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.02 347.11 198.4 334.2 187.8 334.2 191.6 337 185.02 347.11",
    style: {
      fill: "#FECB63",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.86,414.81l3.2,3.64s3,6.82-5.29,15.17-29.78,10-38.14,8.55l-5.27.71L212.43,439s-9.08-4.44-5.37-12.23S275.86,414.81,275.86,414.81Z",
    style: {
      fill: "#FECB63",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.36,432.33c-6.93,7.23-29.13,8.67-38.4,6.56-2.53-.58-11.74-.91-18.6-3.37-3.7-1.31-6.72-3.24-7.64-6.16-2.66-8.33,20.78-24.18,20.78-24.18s14.95,2.88,18.05,3.62a59.14,59.14,0,0,0,11,1.52c7.11.31,11.92-.64,17.13,1.6C278.58,414.47,278.66,423.67,270.36,432.33Z",
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-74)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.51,410.32c-5.34,8.72-18.67,25.46-42.15,25.2-3.7-1.31-6.72-3.24-7.64-6.16-2.66-8.33,20.78-24.18,20.78-24.18s14.95,2.88,18.05,3.62A59.14,59.14,0,0,0,255.51,410.32Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.36,432.33c-6.93,7.23-29.13,8.67-38.4,6.56-2.53-.58-11.74-.91-18.6-3.37-3.7-1.31-6.72-3.24-7.64-6.16-2.66-8.33,20.78-24.18,20.78-24.18s14.95,2.88,18.05,3.62a59.14,59.14,0,0,0,11,1.52c7.11.31,11.92-.64,17.13,1.6C278.58,414.47,278.66,423.67,270.36,432.33Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.25,415.35s23,6.94,27.32,6.49,4.85,3.09,4.85,3.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.94,407s25.24,5.4,28.29,6.3a8.78,8.78,0,0,0,5.59-.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.62,407.4a14.19,14.19,0,0,1-8,11.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.34,408.26a17.64,17.64,0,0,1-6.68,12.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.37,410s1.36,7.38-6.49,12.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.67,410.58s1.19,9.3-6.39,14.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.34,411.39s-.2,9.71-6.59,13.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.79,412.63s1.68,8.25-5.19,13.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.27,401.35c-2.23,15.11-25.53,31.53-25.53,31.53s-6.45-6.05-8.58-5.8-11-.38-11-.38S113,400.44,104.58,400.3c-5.26-.08-20.42-4.69-27.92-16.65-4.46-7.1-6.21-16.8-1.6-29.67,7.6-21.23,45.07-5.59,81.81,14.7,12.2,6.75,23,12.16,31.77,16.28,14.55,6.85,23.4,10.15,23.4,10.15l4.86-1.74Z",
    style: {
      fill: "#FECB63"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-74)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.27,401.35c-2.23,15.11-25.53,31.53-25.53,31.53s-6.45-6.05-8.58-5.8-11-.38-11-.38S113,400.44,104.58,400.3c-5.26-.08-20.42-4.69-27.92-16.65,8.81.65,23.82,2.12,31,4.8,0,0-8,2-5.8,3.92s34.32,5.7,45.62,2.85c10.22-2.57,30.62-9.52,41.18-10.26,14.55,6.85,23.4,10.15,23.4,10.15l4.86-1.74Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.27,401.35c-2.23,15.11-25.53,31.53-25.53,31.53s-6.45-6.05-8.58-5.8-11-.38-11-.38S113,400.44,104.58,400.3c-5.26-.08-20.42-4.69-27.92-16.65-4.46-7.1-6.21-16.8-1.6-29.67,7.6-21.23,45.07-5.59,81.81,14.7,12.2,6.75,23,12.16,31.77,16.28,14.55,6.85,23.4,10.15,23.4,10.15l4.86-1.74Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.14,386.75c2.49-.43,5-.94,7.41-1.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7,388.08c20.33,1.63,41.26,2.09,61.51-.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.23,416.21,95,419.85s-3,6.82,5.28,15.17,29.78,10,38.14,8.55l5.28.71,17.92-3.85S170.74,436,167,428.2,98.23,416.21,98.23,416.21Z",
    style: {
      fill: "#FECB63",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.6,406.58s-14.95,2.88-18.06,3.61c-13.89,3.28-20.59-.09-28.08,3.13-5.94,2.55-6,11.75,2.27,20.41,6.93,7.23,29.13,8.67,38.4,6.56,3.89-.88,23.6-1.23,26.25-9.54S147.6,406.58,147.6,406.58Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.84,416.75s-23,6.94-27.32,6.49-4.85,3.09-4.85,3.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.16,408.37s-25.25,5.41-28.3,6.3a8.75,8.75,0,0,1-5.59-.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.48,408.8a14.19,14.19,0,0,0,8,11.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.75,409.66a17.62,17.62,0,0,0,6.69,12.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.73,411.39s-1.37,7.38,6.48,12.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.42,412s-1.19,9.3,6.39,14.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.76,412.79s.19,9.71,6.59,13.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.31,414s-1.68,8.24,5.18,13.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.57,353.84c-7.65-21.22-45.08-5.51-81.77,14.85-32.44,18-55.13,26.53-55.13,26.53l-4.86-1.72-11.36,8c2.26,15.1,25.6,31.47,25.6,31.47s6.43-6.07,8.57-5.82,11-.4,11-.4,70.16-26.39,78.53-26.54S310,388.39,297.57,353.84Z",
    style: {
      fill: "#FECB63",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.78,408.35c2,.14,4.06.22,6.09.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.67,395.22C168,403,180,406.38,190.22,407.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.24,381.46c14.35,2.73,30.31,5.23,44.75,1.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.23,379.06c2,.51,4.06,1,6.11,1.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.3,216c-.21,1.45-.41,2.87-.56,4.22-3.74,3.83-10,9.1-16,9.28-4.39.13-9-1.75-12.74-3.82a9.58,9.58,0,0,0,.24-1.09c.43-2.59-.26-7-1.26-11.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,191.78s2.73-2.57,4.07-1.72,2.93,3.23,2.2,5.41-3.9,6-4.15,8.2-1.88,4.72-3.68,3.25S210,191.78,210,191.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.38,191.78s-2.73-2.57-4.07-1.72-2.93,3.23-2.19,5.41,3.9,6,4.14,8.2,1.89,4.72,3.68,3.25S161.38,191.78,161.38,191.78Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.1,156.7c35.5,0,25.9,42.92,19.36,58.1-2.29,5.33-13.61,12.8-19.36,12.8-5.35,0-16-7-18.2-12C160.29,200.3,151.27,156.7,185.1,156.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.12,191.48s9.24-2.86,12.1,2.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,199.25c0,1.09-.55,2-1.24,2s-1.23-.89-1.23-2,.55-2,1.23-2S198,198.16,198,199.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.28,191.48s-9.25-2.86-12.11,2.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.43,199.25c0,1.09.56,2,1.24,2s1.24-.89,1.24-2-.56-2-1.24-2S173.43,198.16,173.43,199.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.53,207.36c-1.34,1.43,3.3,3.78,4.17,3.78s4.4-1.85,4.4-2.94",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.84,168.79a45,45,0,0,1-27.36,0s-4.79-.28-6.68,2.13,0,9.84.5,12.87-4.16,5.12-3.53,12.77l-.63,2.89s-5.16-13.14-3.9-23.73,6.93-14.12,6.93-14.12,3.05-9.14,20.91-9.08c19.25.08,21.19,10.5,21.19,10.5s12,9,2.32,37.41l-1-3.87a15.92,15.92,0,0,0-2.44-10.76c-1.68-2.45,1-9.83.38-13.61S199.84,168.79,199.84,168.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,214.62a18,18,0,0,0,7.71,1.68,20,20,0,0,0,7.37-1.25",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.06,172.17a36,36,0,0,0,4.16,11.05c3,4.79,6.54,5.28,7.55,11.12,0,0,9.21-15.54,1.42-29.18,0,0-2.45-15.48-26.49-15.48s-35.17,16.75-25.83,42.47a13.93,13.93,0,0,0,8.3-11.32,13.73,13.73,0,0,1-2.47,9.93s12.38-1.83,15.59-12.15c0,0-1.25,6.86-5.38,9.77,0,0,4.67,5.9,10-3.32S194.45,170.32,199.06,172.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.09,174.18c-1.5,2.15-3.61,5.47-6.66,5.15",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,165.25c-4.05-8.24-12.83,1.86-15.7,5.84",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.08,167.08a9.11,9.11,0,0,1-3.45,1.95",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.07,157.56c-8.17-8.55-19.75,1.39-26.22,7.08",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.57,167.29a17.73,17.73,0,0,1,2.62,7.27",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22,163.7a6.66,6.66,0,0,1,3.68,1",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.74,159.4s1.77-4.69,5.33-1.26",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Progress--inject-74"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 141.7,
    y: 275.76,
    width: 90.8,
    height: 13.04,
    rx: 4.8,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3589553833007812px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.69,279.33a1.22,1.22,0,0,0,1.36-1h.83v7.88h-1.23v-6h-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.28,280.23a1.88,1.88,0,1,1,3.76,0v4.1a1.88,1.88,0,1,1-3.76,0Zm1.24,4.18c0,.56.24.77.64.77s.64-.21.64-.77v-4.26c0-.56-.25-.77-.64-.77s-.64.21-.64.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.74,280.23a1.88,1.88,0,1,1,3.76,0v4.1a1.88,1.88,0,1,1-3.76,0Zm1.23,4.18c0,.56.25.77.65.77s.64-.21.64-.77v-4.26c0-.56-.25-.77-.64-.77s-.65.21-.65.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.23,279.54a1.19,1.19,0,1,1,2.38,0v2.59a1.19,1.19,0,1,1-2.38,0Zm.79,2.65c0,.35.14.5.4.5s.41-.15.41-.5v-2.7c0-.35-.16-.5-.41-.5s-.4.15-.4.5Zm3.51-3.85h.73l-3.11,7.88h-.73Zm-.4,4.09a1.2,1.2,0,1,1,2.39,0V285a1.2,1.2,0,1,1-2.39,0Zm.79,2.64c0,.35.15.5.41.5s.4-.15.4-.5v-2.7c0-.35-.15-.5-.4-.5s-.41.15-.41.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bubble--inject-74"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 117.54,
    cy: 151.13,
    r: 28.1,
    transform: "matrix(0.58, -0.81, 0.81, 0.58, -73.78, 158.48)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.22,129a31,31,0,0,0-41.93-1.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.37,162.43A31,31,0,0,0,141,130.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.75,180l5.64,3.36-4.78-11.56a30.11,30.11,0,0,0,2.2-2.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.29,174.56a31,31,0,0,0,37.35,2.38l2.78,1.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.78,139.64a31,31,0,0,0,5.34,31.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.92,133.74a29,29,0,0,0-1.86,3.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.49,161.24l-9.71-9.35a2.27,2.27,0,0,1,3.15-3.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.57,139.07a2.27,2.27,0,0,1,3.78,2.52l-14.27,21.33a2.26,2.26,0,0,1-1.64,1l-.2,0a2.29,2.29,0,0,1-1.62-.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "108.14 150.76 115.81 158.14 126.7 141.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407,152.6s-14-1.55-22.57-16.92-54.6-10.32-54.6-10.32.27,5.38,7.39,6.77l-5,2.4s1.46,6.16,14.5,5.61L343.24,144s5.48,4.47,19.22,2.51l-2.59,3.33s6.42,4.47,17.32,1.33L376,154.22s8.26.6,13.13-1.53C389.15,152.69,398.57,158.5,407,152.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-74)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407,152.61c-8.46,5.89-17.88.09-17.88.09-4.87,2.11-13.13,1.53-13.13,1.53l1.16-3.1c-10.89,3.15-17.31-1.33-17.31-1.33l2.59-3.33c-13.74,2-19.22-2.52-19.22-2.52l3.54-3.8c-13,.53-14.49-5.62-14.49-5.62l5-2.39c-7.12-1.4-7.39-6.78-7.39-6.78s2.61,4.65,10.13,4.5c0,0-1.26,3.14,6.44,3.72,0,0,6.51,2.77,11.23.7,0,0,1.58,3.22,7.24,2.67L363,139.48s.59,3.32,7.6,1.67l-1,3.26s2.3,2.67,11.32.68c0,0-2.82,1.84-1.89,2.78s3.77,1.39,6.23,1.15C385.22,149,394.85,156.61,407,152.61Z",
    style: {
      fill: "#FECB63",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M407,152.6s-14-1.55-22.57-16.92-54.6-10.32-54.6-10.32.27,5.38,7.39,6.77l-5,2.4s1.46,6.16,14.5,5.61L343.24,144s5.48,4.47,19.22,2.51l-2.59,3.33s6.42,4.47,17.32,1.33L376,154.22s8.26.6,13.13-1.53C389.15,152.69,398.57,158.5,407,152.6Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.4,128.28c-4.63,1.17-7.43.8-10.87,2.55,0,0,3,4.1,10.9,3.55",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.92,136a32.73,32.73,0,0,0-5.82,1.82s1.14,5.33,13.65,2.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.62,142.34,360,144.7a21.78,21.78,0,0,0,13.4,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,145.79s-3.58,2.52-3.46,2.87,7.17,3,13.55-.47",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,129.79c-2.19,1-8.68,1.94-9.11,2.89,0,0,2.12,5.94,13,2.59",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.29,136.72a18.84,18.84,0,0,0-4.61,2.66s4.22,5.86,14.47.8",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.45,140.17a7.27,7.27,0,0,0-3.89,4.24s5.07,3.28,13.76-.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,131.82s-6.18,1.32-6.35,2.46c0,0,5,4.27,12.91,2.12",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.49,135.85a7,7,0,0,0-2.44,2.05s2.39,3.54,8.55,1.61",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,131.11l-4.84,1.67-2.32-4.85a1.08,1.08,0,0,0-1.35-.56L389,133a1.32,1.32,0,0,0-.86,1.33l.43,5.49-27.49,9.47a2.74,2.74,0,0,0-1.72,3.26l11.1,41.85a2.31,2.31,0,0,0,3,1.62l52.89-18.22a2.76,2.76,0,0,0,1.73-3.26L417,132.74A2.32,2.32,0,0,0,414,131.11Z",
    style: {
      fill: "#FECB63"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-74)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414,131.11l-4.84,1.67-2.32-4.85a1.08,1.08,0,0,0-1.35-.56L389,133a1.32,1.32,0,0,0-.86,1.33l.43,5.49-27.49,9.47a2.74,2.74,0,0,0-1.72,3.26l11.1,41.85a2.31,2.31,0,0,0,3,1.62l52.89-18.22a2.76,2.76,0,0,0,1.73-3.26L417,132.74A2.32,2.32,0,0,0,414,131.11Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M414,131.11l-4.84,1.67-2.32-4.85a1.08,1.08,0,0,0-1.35-.56L389,133a1.32,1.32,0,0,0-.86,1.33l.43,5.49-27.49,9.47a2.74,2.74,0,0,0-1.72,3.26l11.1,41.85a2.31,2.31,0,0,0,3,1.62l52.89-18.22a2.76,2.76,0,0,0,1.73-3.26L417,132.74A2.32,2.32,0,0,0,414,131.11Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.08,177.89l-52.89,18.22a2.92,2.92,0,0,1-3.48-1.47l-.26-.53L357,168.28l-6.17-12.76a2.2,2.2,0,0,1,1.27-3.11L405,134.2a2.9,2.9,0,0,1,3.48,1.46l18.91,39.13A2.19,2.19,0,0,1,426.08,177.89Z",
    style: {
      fill: "#FECB63"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-74)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.3,168.63a15.61,15.61,0,0,1-13,14.12,29.86,29.86,0,0,1-5.83,11.36L357,168.28C367.53,170.1,379.65,171.12,388.3,168.63Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M426.08,177.89l-52.89,18.22a2.92,2.92,0,0,1-3.48-1.47l-.26-.53L357,168.28l-6.17-12.76a2.2,2.2,0,0,1,1.27-3.11L405,134.2a2.9,2.9,0,0,1,3.48,1.46l18.91,39.13A2.19,2.19,0,0,1,426.08,177.89Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.3,168.62s-13.72,3-26.81-8.78-55,7.74-55,7.74,2,5,9.16,4l-3.93,3.87s3.35,5.36,15.53.66l-2.13,4.75s6.62,2.48,19-3.79l-1.39,4s7.52,2.17,16.83-4.29l-.11,3.3s8-2.09,11.95-5.66C371.4,174.45,382.18,176.92,388.3,168.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-9--inject-74)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.3,168.63c-6.12,8.29-16.9,5.82-16.9,5.82-3.93,3.57-11.95,5.66-11.95,5.66l.11-3.31c-9.31,6.48-16.83,4.3-16.83,4.3l1.39-4c-12.38,6.28-19,3.79-19,3.79l2.13-4.74c-12.18,4.69-15.53-.67-15.53-.67l3.94-3.87c-7.2,1-9.18-4-9.18-4s4,3.56,11,1c0,0-.19,3.38,7.29,1.46,0,0,7.06.54,10.86-2.94,0,0,2.54,2.54,7.72.21l-1,3s1.62,2.95,7.74-.86l.07,3.42s3,1.78,10.95-3c0,0-2.08,2.65-.91,3.24s4,.1,6.28-.91C366.5,172.23,378.05,176.33,388.3,168.63Z",
    style: {
      fill: "#FECB63",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.3,168.62s-13.72,3-26.81-8.78-55,7.74-55,7.74,2,5,9.16,4l-3.93,3.87s3.35,5.36,15.53.66l-2.13,4.75s6.62,2.48,19-3.79l-1.39,4s7.52,2.17,16.83-4.29l-.11,3.3s8-2.09,11.95-5.66C371.4,174.45,382.18,176.92,388.3,168.62Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,164.72c-4,2.6-6.78,3.13-9.47,5.9,0,0,4.19,2.91,11.46-.14",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.82,170.86a32.5,32.5,0,0,0-4.92,3.59s2.78,4.69,13.81-1.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.9,172.83l-2.71,3.41a21.78,21.78,0,0,0,13-3.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.63,171.82s-2.58,3.53-2.35,3.83,7.75.54,12.68-4.8",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.72,163.7c-1.77,1.6-7.6,4.62-7.7,5.66,0,0,3.92,4.95,13.17-1.72",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.83,167.93a18.94,18.94,0,0,0-3.51,4s5.88,4.2,14-3.88",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.51,167.62a7.26,7.26,0,0,0-2.32,5.27s5.84,1.48,13-4.54",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.88,162.74s-5.43,3.24-5.22,4.37c0,0,6.07,2.45,12.9-2.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.27,164.16a6.84,6.84,0,0,0-1.65,2.72s3.4,2.59,8.61-1.21",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.32,310.93c1.19-.4,2.45-.86,3.76-1.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.63,307.65c22.56-10.1,55.6-34.3,48.49-73.68-5.86-32.4-32.65-29.51-40.71-22.83-13.67,11.34-15.75,38,4,43.58,32.8,9.19,57.73-31.76,65.88-47.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      strokeDasharray: "7.9028801918029785,4.939300060272217"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.46,205.18c1.13-2.26,1.72-3.61,1.72-3.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadimg);
export default __webpack_public_path__ + "static/media/uploadimg.d2a0599d.svg";
export { ForwardRef as ReactComponent };